module.exports = __webpack_public_path__ + "img/hic-leukaemia-female.992267f9.png";